export const get_transaction_query = `
query get_transaction {
  transaction {
    amount
    card_brand
    card_number
    charge_amount
    charge_currency
    created_at
    currency
    descriptor
    error_message
    fee_amount
    message
    new_attempt
    new_attempt_same_details
    ob_additional_fields_filled
    ob_decline_recovery
    payment_method
    payment_processor
    processing_in_progress
    promocode_title
    retry_with_apm
    show_reject_reason
    status
    submit_action
    submit_name
    trace_id
    transaction_id
    transaction_type
    is_crypto
    retry_settings {
      fees
      payment_information {
        base_currency
        crypto
        currency_list
        max_amount
        min_amount
        rate
        spread_rate
      }
      show_amount_field
      predefined_options {
        amount
        currency
      }
    }
  }  
}
`;